import React from "react";

import address from "../img/address.svg"
import calendar from "../img/calendar.svg"
import checkOn from '../img/done-icon.svg'
import checkOff from '../img/close-icon.svg'

import { Button, Divider } from "@mui/material";
import { eventDatesFormatter, parseToEasternTime } from './../utils/dates';


export default function JobDescription({ currentJob }) {

  if (currentJob) {
    var date = parseToEasternTime(currentJob.currentOwnerStarted)
  }
  return (

    <div className="job-description">

      <div className="id-date">
        <div>
          <p className="job-card-id" style={{ color: "var(--grey-inactive)" }}>
            ID: {currentJob.id}
          </p>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }} >
          <p className="job-card-id " style={{ color: "var(--grey-inactive)" }}>
            Job started date
          </p>
          <p className="job-card-id" style={{ margin: '0' }}>
            {date}
          </p>
        </div>
      </div>
      <div className="top-info" >
        <div className=" job-card-description" >
          <a href={currentJob.primaryUrl} target="_blank" rel="noreferrer" style={{ display: 'flex' }} >
            <h4 className="job-card-description-title">
              {currentJob.name}
            </h4>
          </a>
          <div className="job-card-description-content">
            <img src={calendar} style={{ marginRight: '0.5em' }} alt="Calendar Icon" />
            <p className="job-card-description-text">{eventDatesFormatter(currentJob.date)}</p>
          </div>
          <div className="job-card-description-content">
            <img src={address} style={{ marginRight: '0.5em' }} alt="Location Icon" />
            <p className="job-card-description-text"> {currentJob.venue.name} ( {currentJob.venue.city}, {currentJob.venue.state} )</p>
          </div>
        </div>
        <div className=" job-card-actions">
          <div className="job-card-actions-button-reward"  >
            ${currentJob.rewardAmt}
          </div>
        </div>

      </div>

      <Divider style={{ margin: '1em 0' }} />

      <div className="job-card-information">

        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
          <p
            style={{
              color: "var(--orange)",
              fontWeight: "700",
              margin: "0 0.5em 0 0",
            }}
          >
            Quantity:
          </p>
          <p style={{ fontWeight: "700" }}>{currentJob.quantity}</p>
        </div>

        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
          <p
            style={{
              color: "var(--orange)",
              fontWeight: "700",
              margin: "0 0.5em 0 0",
            }}
          >
            Section:
          </p>
          <p style={{ fontWeight: "700" }}>{currentJob.section}</p>
        </div>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
          <p
            style={{
              color: "var(--orange)",
              fontWeight: "700",
              margin: "0 0.5em 0 0",
            }}
          >
            Row:
          </p>
          <p style={{ fontWeight: "700" }}>{currentJob.row}</p>
        </div>

        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
          <p
            style={{
              color: "var(--orange)",
              fontWeight: "700",
            }}
          >
            Cost Per Ticket:
          </p>
          <p style={{ fontWeight: "700" }}>
            ${currentJob.perTicketOTDEst}
          </p>
        </div>

        <div className="instructions-checkbox">
          <img
            src={currentJob.includesFees ? checkOn : checkOff}
            alt="ok icon"
            height="24px"
            style={{ margin: "0 0.25em 0 0" }}
          />

          <p
            style={{ color: "var(--orange)", fontWeight: "700" }}
            htmlFor="newBee"
          >
            {currentJob.includesFees ? "Cost Includes Fees" : "Cost doesn’t Include Fees"}
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", gap: "0.5em" }}>
          <p
            style={{
              color: "var(--orange)",
              fontWeight: "700",
              margin: "0 0.5em 0 0",
            }}
          >
            Code to Use:
          </p>
          <p style={{ fontWeight: "700" }}>{currentJob.codeToUse || "-"}</p>
        </div>


      </div>
      {/* -------------------------------------- */}

      <Divider style={{ margin: '1em 0' }} />

      {/* -------------------------------------- */}

      <div className="special-instructions">
        <h4 style={{ color: "var(--orange)", fontWeight: "600", margin: '0 0 0.25em 0' }}>
          Special Instructions
        </h4>
        <p style={{ font: "var(--p2)" }}>
          {currentJob.specialInstructions}
        </p>
      </div>
    </div>
  );
}